// F1 Data Visualization Component
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../modules/HeaderModule';
import F1Breadcrumb from './F1Breadcrumb';

const F1HomeComponent = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'races',
      title: 'Races',
      description: 'Race results, statistics, and historical data from Formula 1 events',
      icon: '🏁',
      color: 'red',
      route: '/f1/races'
    },
    {
      id: 'seasons',
      title: 'Seasons',
      description: 'Season summaries, championship battles, and yearly statistics',
      icon: '📅',
      color: 'orange',
      route: '/f1/seasons'
    },
    {
      id: 'drivers',
      title: 'Drivers',
      description: 'Driver profiles, career statistics, and performance analysis',
      icon: '👤',
      color: 'blue',
      route: '/f1/drivers'
    },
    {
      id: 'teams',
      title: 'Teams',
      description: 'Constructor information, team performance, and championship history',
      icon: '🏆',
      color: 'green',
      route: '/f1/teams'
    },
    {
      id: 'circuits',
      title: 'Circuits',
      description: 'Circuit information, track characteristics, and race venue data',
      icon: '🏎️',
      color: 'purple',
      route: '/f1/circuits'
    },
    {
      id: 'awards',
      title: 'Awards',
      description: 'Championship titles, awards, and special achievements',
      icon: '🏅',
      color: 'yellow',
      route: '/f1/awards'
    },
    {
      id: 'grill-the-grid',
      title: 'Grill The Grid',
      description: 'Driver grid position challenge results and standings',
      icon: '🔥',
      color: 'red',
      route: '/f1/grill-the-grid'
    },
    {
      id: 'data-viewer',
      title: 'Data Viewer',
      description: 'Interactive data exploration and analysis tools',
      icon: '📊',
      color: 'indigo',
      route: '/f1/data-viewer'
    }
  ];

  const handleCategoryClick = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen theme-bg-secondary"> 
      <div className="max-w-7xl mx-auto">
        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category.route)}
              className="theme-bg rounded-lg shadow-lg p-6 cursor-pointer transform transition-all duration-200 hover:scale-105 hover:shadow-xl border-2 theme-border-secondary hover:border-gray-400"
            >
              <div className="flex items-center mb-4">
                <div className="text-4xl mr-4">{category.icon}</div>
                <div>
                  <h3 className="text-xl font-bold theme-primary">{category.title}</h3>
                </div>
              </div>
              <p className="theme-secondary text-sm leading-relaxed">
                {category.description}
              </p>
              <div className="mt-4 flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm">
                <span>Explore {category.title}</span>
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
        
        {/* Recent Updates */}
        <div className="mt-8 text-center">
          <p className="theme-secondary text-sm">
            Data is being updated with the latest Formula 1 information, please be patient while we sort out the bugs. 
            Click on any category above to start exploring detailed statistics and analysis.
          </p>
        </div>
      </div>
    </div>
  );
};

export default F1HomeComponent;
